import { useContext } from "react";
import { DriveContext } from "@/store/DriveContext";

interface IGameTopBar {
  timer: number;
  userRating: number;
  oppUsername: string;
  oppRating: number;
  score: number;
  oppScore: number;
  hideScore?: boolean;
  hideTimer?: boolean;
}

function GameTopBar({ timer, userRating, oppUsername, oppRating, score, oppScore, hideScore = false, hideTimer = false }: IGameTopBar) {
  const { user } = useContext(DriveContext)!;

  return (
    <div className="flex items-center justify-between p-3 sm:p-5 bg-[#101020]/80 backdrop-blur-md border-b border-violet-500/10 shrink-0">
      
      {/* Player (YOU) Side */}
      <div className="flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-violet-500 to-indigo-500 rounded-lg flex items-center justify-center text-[12px] sm:text-[14px] font-bold text-white shrink-0 shadow-[0_0_10px_rgba(139,92,246,0.3)]">
          {user?.username?.[0]?.toUpperCase() ?? "U"}
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-[10px] sm:text-[11px] font-bold text-violet-400 uppercase tracking-wider truncate">YOU</span>
          <span className="text-[10px] sm:text-[11px] font-medium text-gray-500">{userRating}</span>
        </div>
        {!hideScore && <div className="ml-1 sm:ml-2 text-[20px] sm:text-[24px] font-extrabold text-white">{score}</div>}
      </div>

      {/* Center Clock */}
      {!hideTimer && (
        <div className="flex flex-col items-center justify-center shrink-0 mx-2">
          <div className={`w-11 h-11 sm:w-12 sm:h-12 rounded-full border-2 flex items-center justify-center bg-[#0a0a12] transition-colors duration-300 ${timer <= 10 ? 'border-red-500/40 shadow-[0_0_12px_rgba(239,68,68,0.3)]' : 'border-indigo-500/30 shadow-[0_0_12px_rgba(99,102,241,0.2)]'}`}>
            <span className={`text-[16px] sm:text-lg font-bold tabular-nums ${timer <= 10 ? 'text-red-400 animate-pulse' : 'text-indigo-300'}`}>
              {timer}
            </span>
          </div>
        </div>
      )}

      {/* Opponent Side */}
      <div className="flex items-center justify-end gap-2 sm:gap-3 flex-1 min-w-0 text-right">
        {!hideScore && <div className="mr-1 sm:mr-2 text-[20px] sm:text-[24px] font-extrabold text-white">{oppScore}</div>}
        <div className="flex flex-col min-w-0 items-end">
          <span className="text-[10px] sm:text-[11px] font-bold text-red-400 uppercase tracking-wider truncate">{oppUsername || "OPP"}</span>
          <span className="text-[10px] sm:text-[11px] font-medium text-gray-500">{oppRating}</span>
        </div>
        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-red-500 to-rose-500 rounded-lg flex items-center justify-center text-[12px] sm:text-[14px] font-bold text-white shrink-0 shadow-[0_0_10px_rgba(239,68,68,0.3)]">
          {oppUsername?.[0]?.toUpperCase() ?? "?"}
        </div>
      </div>

    </div>
  );
}

export default GameTopBar;